module.exports = {"130924100":"苏基镇","130924101":"辛集镇","130924102":"高湾镇","130924200":"赵毛陶乡","130924201":"香坊乡","130924202":"小山乡","130924203":"张会亭乡","130924400":"海兴县农场","130924401":"青先农场","130924402":"青锋农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130924.json
// module id = 195
// module chunks = 0